import { createContext, useEffect, useState } from "react";

const addCartItem = (cartItems, productToAdd) => {
  let result;

  const existingCartItem = cartItems.find(ci => ci.id === productToAdd.id);

  if (existingCartItem) {
    result = cartItems.map(ci =>
      ci.id === productToAdd.id
        ? { ...ci, quantity: ci.quantity + 1 }
        : ci
    );
  } else {
    result = [...cartItems, { ...productToAdd, quantity: 1 }];
  }

  return result;
};

export const CartContext = createContext({
  isCartOpen: false,
  cartItems: [],
  totalCartPrice: 0,
  setIsCartOpen: () => { },
  addItemToCart: () => { },
  totalCartQuantity: () => { },
  removeCartItem: () => { },
});

export const CartProvider = ({ children }) => {
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [totalCartPrice, setTotalCartPrice] = useState(0);

  useEffect(() => {
    const totalPrice = cartItems.reduce((total, ci) => total + ci.price * ci.quantity, 0);
    setTotalCartPrice(totalPrice);
  }, [cartItems])

  const totalCartQuantity = () => {
    return cartItems.reduce((totalQuantity, ci) => {
      totalQuantity += ci.quantity;
      return totalQuantity;
    }, 0)
  };

  const removeCartItem = (item) => {
    let result;

    if (item.quantity === 1) {
      result = cartItems.filter(ci => ci.id !== item.id);
    } else {
      result = cartItems.map(ci =>
        ci.id === item.id
          ? { ...ci, quantity: ci.quantity - 1 }
          : ci
      )
    }

    setCartItems(result);
  }

  const addItemToCart = (product) => {
    setCartItems(addCartItem(cartItems, product));
  };

  const value = {
    isCartOpen,
    setIsCartOpen,
    cartItems,
    addItemToCart,
    totalCartQuantity,
    totalCartPrice,
    removeCartItem,
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>
};